<template>
    <div class="products box">
        <div class="insert-role">
            <h2>{{ t('places-products-title') }}</h2>
        </div>
        <table class="table table--list">
            <thead>
                <tr>
                    <th>{{ t('name') }}</th>
                    <th>{{ t('status') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in placeProductsList" :key="product.id">
                    <td>
                        <label
                            :for="`product-input-${product.id}`"
                            class="form-check-label"
                            :class="{ 'text-muted': !product.enabled }"
                        >
                            {{ productLabel(product) }}
                        </label>
                    </td>
                    <td>
                        <input
                            v-model="product.enabled"
                            :id="`product-input-${product.id}`"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <div>
            <button
                class="btn btn-primary pull-right"
                :disabled="!isModifiedForm || saving"
                @click.prevent="saveProducts()"
            >
                {{ t('save') }}
            </button>
        </div>
        <div class="clear"></div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import keviApi from "../../../keviApi";

export default {
    computed: {
        ...mapState({
            placeId: (state) => state.placeDetails.id,
        }),
        placeProductsList() {
            return Object.values(this.placeProducts).sort(
                (a, b) => a.id - b.id,
            );
        },
        isModifiedForm() {
            return (
                JSON.stringify(this.startPlaceProducts) !==
                JSON.stringify(this.placeProducts)
            );
        },
    },
    data() {
        return {
            saving: false,
            products: {},
            placeProducts: {},
            startPlaceProducts: {},
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        productLabel(product) {
            const key = `places-products-names-${product.id}`;
            const translated = this.t(key);
            return translated === key ? product.name : translated;
        },
        withProductsOutsideList(list = null, enabled = false) {
            list = JSON.parse(JSON.stringify(list || {}));
            Object.keys(this.products).forEach((key) => {
                if (!list.hasOwnProperty(key)) {
                    list[key] = {
                        id: Number(key),
                        name: this.products[key].name,
                        enabled,
                    };
                }
            });
            return list;
        },
        getProductsList() {
            const options = keviApi.getOptions("places/kevi-products", "GET");
            return this.$http(options).then(
                (response) => (this.products = response.body),
            );
        },
        getPlaceProducts() {
            const options = keviApi.getOptions(
                `places/kevi-products/${this.placeId}`,
                "GET",
            );
            return this.$http(options).then((response) => {
                this.placeProducts = this.withProductsOutsideList(response.body);
                this.startPlaceProducts = JSON.parse(
                    JSON.stringify(this.placeProducts),
                );
            });
        },
        saveProducts() {
            this.saving = true;
            const options = keviApi.getOptions(
                `places/kevi-products/${this.placeId}`,
                "POST",
                {
                    products: Object.assign({}, this.placeProducts),
                },
            );
            this.$http(options)
                .then(async () => {
                    await this.getPlaceProducts();
                    this.$store.dispatch(
                        "notification/success",
                        this.t("places-products-updated"),
                    );
                })
                .catch(async (response) => {
                    const message =
                        response?.body?.error ===
                        "at-least-one-product-required"
                            ? this.t("places-products-at_least_one")
                            : this.t("places-products-update_error");
                    await this.$store.dispatch("notification/error", message);
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
    async beforeMount() {
        await this.getProductsList();
        await this.getPlaceProducts();
    },
};
</script>
<style lang="less" scoped>
.insert-role {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.form-check-input,
.form-check-label {
    cursor: pointer;
}
</style>
